<app-page-nav>
  <div class="page-content"><router-outlet></router-outlet></div>
</app-page-nav>
